import _debounce from 'lodash/debounce';
import React from 'react';
import { ChildDataProps } from 'react-apollo';
import { SortingRule } from 'react-table';
import { ListGroupContactsQuery } from 'typings/types';
import { SortDirection } from '../../../constants/queryConstants';
import InfiniteTable from '../../../containers/InfiniteTable/InfiniteTableContainer';
import ListViewLayout from '../../ListViewLayout/ListViewLayout';
import { hasMoreRecords } from 'utils/directoryUtils';
import { groupContactsTabColumnConfig } from './GroupContactsColumnConfig';
import GroupContactsHeader from './GroupContactsHeader';
import { Logger } from 'logger';

interface Props {
  fetchMoreRows: () => Promise<{}>;
  showEditUserModal: (contact: Object) => void;
}

type DirectoryListResponse = {
  directoryList: ListGroupContactsQuery.DirectoryList;
};

let isMounted: boolean;

class GroupContactsTab extends React.Component<ChildDataProps<Props, DirectoryListResponse>> {
  searchQuery: string | null = null;
  onFilterStringChange: (filter: string) => void = _debounce(
    (filter: string) => {
      this.searchQuery = filter === '' ? null : filter;
      try {
        this.props.data.refetch({
          query: this.searchQuery,
          sort: null,
        });
      } catch (e) {
        Logger.info(`Error fetching more user records:  ${e.toString()}`);
      }
    },
    250);

  onFetchData: (args: { sorted: Array<SortingRule> }) => void = ({
                                                                   sorted: [column],
                                                                 }) => {
    if (!column || !this.props.data) {
      return;
    }
    this.props.data.refetch({
      sort: {
        propertyName: column.id,
        direction: column.desc ? SortDirection.DESC : SortDirection.ASC
      },
    });
  }

  componentDidMount() {
    isMounted = true;
  }

  componentWillUnmount() {
    isMounted = false;
  }

  render() {
    const {
      data: { loading, directoryList } = {
        loading: false,
        directoryList: null,
      },
      showEditUserModal,
    } = this.props;

    const listData = !loading && directoryList ? directoryList.records : [];

    return (
      <ListViewLayout
        hideHeader={true}
        isFetching={false}
        numberOfPages={0}
      >
        <InfiniteTable
          defaultSort={!this.searchQuery ? [
            {
              id: 'displayName'
            },
          ] : []}
          columnConfig={groupContactsTabColumnConfig(listData, showEditUserModal)}
          data={listData as ListGroupContactsQuery.GroupContactInlineFragment[]}
          fetchMore={() => {
            if (isMounted.current) {
              return this.props.fetchMoreRows();
            } else {
              return Promise.resolve({});
            }
          }}
          hasMoreRecords={hasMoreRecords(this.props.data)}
          keyField={'UUID'}
          loading={loading}
          onFetchData={this.onFetchData}
          enableSelect={true}
          renderHeader={() => (
            <GroupContactsHeader
              onFilterStringChange={this.onFilterStringChange}
            />
          )}
          sortable={true}
        />
      </ListViewLayout>
    );
  }
}

export default GroupContactsTab;
